<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :form="form"
    :title="$t('model.user')"
    :actions="actions"
    :batch-actions="batchActions"
    resource="users"
    :tabs="tabs"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/users.js';
import { columnsExtend as studentColumnsExtend  } from '../admin_grapes/students.js';
import { columnsExtend as memberColumnsExtend  } from '../admin_entities/member_detail.js';
import _ from 'lodash';

@Component
export default class Users extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  get tabs() {
    return [{
      label: this.$t('model.user'),
      columns: this.columns(this.$createElement, { type: 'show' })
    }, {
      label: this.$t('model.inviteRelationship'),
      renderCell: (h, user) => {
        if (!_.get(user, 'invite_relationship')) {
          return h('span', '未绑定手机号');
        }
        return <el-tree
          load={(node, resolve) => {
            if (node.level === 0) {
              resolve(_.map([user.invite_relationship], ir => ({ ...ir, label: _.join(_.compact([ir.name, ir.phone]), '-') })));
            } else if (node.level > 0) {
              this.$request.get(`/invite_relationships/${node.data.id}`).then(ir => {
                resolve(_.map(ir.children, ir => ({ ...ir, label: _.join(_.compact([ir.name, ir.phone]), '-') })));
              })
            }
          }}
          lazy>
        </el-tree>
      }
    }, {
      label: '学员导入信息',
      columns: studentColumnsExtend(_.map([
        'user',
        'name',
        'city',
        'gender',
        'nps_source',
        'phone',
        'occupation',
        'student',
        'holder',
        'bridge',
        'partner',
        'potential',
        'height',
        'weight',
        'remark',
        'youth_camp_course_numbers',
        'book_club_course_numbers',
        'course_times',
        'courses_count',
        'course_stickiness',
        'nps_value',
        'nps_list',
      ], attr => ({ key: attr, prop: `student.${attr}` })))
    }, {
      label: '青训营学员信息',
      columns: memberColumnsExtend(_.map([
        'know_channel',
        'name',
        'gender',
        'live_city',
        'company',
        'position',
        'business_experience',
        'vaccination_record_image',
      ], attr => ({ key: attr, prop: `member.${attr}` })))
    }]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'screen_name_cont'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'avatar',
      {
        key: 'screen_name',
        minWidth: 100,
        renderCell: {
          component: (h, { props: { value, scope: { row } } }) => {
            if (row.sns_authorized) {
              return (<span>{value}</span>)
            } else {
              return <el-tag type='info'>{this.$t('unauthorized')}</el-tag>;
            }
          }
        }
      },
      {
        prop: 'profile.phone',
        label: this.$t('inviteRelationship.phone'),
        width: 120,
      },
      'invitees_count',
      'like_posts_count',
      'star_posts_count',
      'view_posts_count',
      'share_posts_count',
      'is_block',
      'parent_user',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */

  actions({ row }, { remove, reload }) {
    return [
      row.is_block && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.isBlockToFalse'),
          can: 'users.update',
          type: 'primary'
        },
        on: {
          confirm: async () =>  {
            await this.$autoLoading(this.$request.put(`/users/${row.id}/is_block_to_false`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      !row.is_block && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.isBlockToTrue'),
          can: 'users.update',
          type: 'primary'
        },
        on: {
          confirm: async () =>  {
            await this.$autoLoading(this.$request.put(`/users/${row.id}/is_block_to_true`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'users.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }
}

export const route = [
  {
    path: '/users',
    name: 'users.index',
    component: Users,
    props: {
      type: 'index',
    }
  },
  {
    path: '/users/new',
    name: 'users.new',
    component: Users,
    props: {
      type: 'new',
    }
  },
  {
    path: '/users/:id',
    name: 'users.show',
    component: Users,
    props: {
      type: 'show',
    }
  },
  {
    path: '/users/:id/edit',
    name: 'users.edit',
    component: Users,
    props: {
      type: 'edit'
    }
  }
]
</script>
